import { UPDATE_PROFILE } from "../actionTypes/profile";

export const updateProfile = (data) => {
  return { type: UPDATE_PROFILE, data };
};
